import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  focusAfterTimeout,
} from '../../util';

import {
  getSevenImperative,
  getSevenImperatives,
  getImperativesStages,
} from '../../util/data';

import { getIcon } from '../../util/icons';

import { NumericalInput } from '../shared';

import Select from 'react-select';

import moment from 'moment';

import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

import {
  createOrUpdateDeal
} from '../../actions/deals';

const STATUS_OPTIONS = [{
  label: 'Open',
  value: 'open'
},{
  label: 'Won',
  value: 'won'
},{
  label: 'Lost',
  value: 'lost'
}];

const DEFAULT_DEAL = {
  name: '',
  estimatedValue: '',
  estimatedCloseDate: moment().valueOf(),
  product: '',
  status: 'open',
}

class UpdateDealModal extends Component{

  state = {
    deal: DEFAULT_DEAL,
    isCreatingNewDeal: false,
    saving: false,
    error: null,
    verifyingChecklist: false,
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.visible && !this.props.visible){
      focusAfterTimeout(this, 'dealNameInput');
    }
    if(nextProps.editingDeal){
      this.setState({
        deal: nextProps.editingDeal,
        isCreatingNewDeal: !nextProps.editingDeal._id,
        verifyingChecklist: false,
      });

      console.log('editingDeal: ', nextProps.editingDeal);
    }
  }

  updateDealProp(propName, propValue){
    this.setState({
      deal: {
        ...this.state.deal,
        [propName]: propValue
      }
    });
  }

  clearError(){
    this.setState({
      error: null,
    });
  }

  createOrUpdateDeal(){

    if(this.state.deal.status === 'won' && this.state.deal._id && !this.state.verifyingChecklist){
      //verify checklist first since this deal is marked as "won"
      this.setState({
        verifyingChecklist: true
      });

      return;
    }

    if(this.state.saving){
      return;
    }

    this.setState({
      saving: true
    });

    this.props.createOrUpdateDeal(this.state.deal, this.onUpdateSuccess.bind(this));
  }

  onUpdateSuccess(deal){
    this.setState({
      saving: false
    }, () => {
      if(this.state.isCreatingNewDeal){
        this.props.onCreate(deal);
      }
      else{
        //if updated existing deal
        this.props.onUpdate(deal);
      }
    });
  }

  renderFormMessage(){
    if(this.state.error){
      return <div className="form-message error">{this.state.error}</div>;
    }
    else{
      return null;
    }
  }

  formIsDirty(){

    console.log('updating deal: ', this.props.editingDeal);

    const {
      _id,
      name,
      product,
      estimatedValue,
      estimatedCloseDate,
      status,
    } = this.props.editingDeal;

    if( !_id ||
      name !== this.state.deal.name ||
      estimatedValue !== this.state.deal.estimatedValue ||
      estimatedCloseDate !== this.state.deal.estimatedCloseDate ||
      product !== this.state.deal.product ||
      status !== this.state.deal.status
     ){
       return true;
     }
    else{
      return false;
    }
  }

  getSaveButtonText(){
    const { deal, saving, verifyingChecklist } = this.state;

    if(deal._id){
      if(saving){
        return "Updating...";
      }
      else{
        if(verifyingChecklist){
          return "Looks Good";
        }
        else{
          return "Update Deal";
        }
      }
    }
    else{
      if(saving){
        return "Adding...";
      }
      else{
        return "Add Deal";
      }
    }

  }

  getOptionForValue(options, value){
    return _.find(options, option => {
      return option.value === value;
    });
  }

  getImperativeStatus(id){
    //let hasFailedTask = false;
    let allTasksComplete = true;

    // console.log('checking imperative status: ', id);

    _.each(getSevenImperative(id).tasks, task => {
      const taskStatus = this.getImperativeTaskStatus(task.id);
      // console.log(`subtask [${task.id}]: ${taskStatus}`);
      if(taskStatus !== 'complete'){
        //hasFailedTask = true;
        allTasksComplete = false;
      }
    });

    return allTasksComplete ? 'complete' : 'incomplete';
  }
  getImperativeTaskStatus(id){
    const item = (this.state.deal.imperativeTasks || {})[id];

    if(item === 'complete'){
      return 'complete';
    }
    else if(item === 'failed'){
      return 'failed';
    }
    else{
      return 'incomplete';
    }
  }

  getFunnelTaskStatus(funnelTask){

    if(funnelTask.imperativeId){
      //check if imperative is complete
      return this.getImperativeStatus(funnelTask.imperativeId);
    }
    else if(funnelTask.imperativeTaskId){
      //check if imperative item is complte
      return this.getImperativeTaskStatus(funnelTask.imperativeTaskId)
    }
    else{
      const item = (this.state.deal.funnelTasks || {})[funnelTask.id];

      if(item === 'complete'){
        return 'complete';
      }
      else if(item === 'failed'){
        return 'failed';
      }
      else{
        return 'incomplete';
      }
    }
  }

  renderImperativeTask(imperativeTask){
    const { id, text, imperative } = imperativeTask;

    const itemStatus = this.getImperativeTaskStatus(id);

    const isComplete = itemStatus === 'complete';
    const isFail = itemStatus === 'failed';
    const isIncomplete = itemStatus === 'incomplete';

    return (
      <li
        key={id}
        className={`imperative-item ${itemStatus}`}
      >
        <div className="imperative-item-text">{text}</div>
        <div className="imperative-item-check">{isComplete ? getIcon('check-fill') : (isFail ? getIcon('check-fail') : getIcon('check-empty'))}</div>
      </li>
    );
  }

  renderImperative(imperative){

    const { id, name, tasks } = imperative;

    return(
      <li key={id} className="imperative">
        <h6>{name}</h6>
        <ul>{_.map(tasks, this.renderImperativeTask.bind(this))}</ul>
      </li>
    )
  }

  renderFunnelTask(funnelTask){

    const { id, stage, imerativeItem, imperative, text} = funnelTask;

    const itemStatus = this.getFunnelTaskStatus(funnelTask);

    const isComplete = itemStatus === 'complete';
    const isFail = itemStatus === 'failed';
    const isIncomplete = itemStatus === 'incomplete';

    return(
      <div
        key={id}
        className={`stage-item stage-item-${id} ${itemStatus}`}
      >
      <div
        className="stage-item-check">{isComplete ? getIcon('check-fill') : (isFail ? getIcon('check-fail') : getIcon('check-empty'))}</div>
        <div className="stage-item-text">{text}</div>
      </div>
    )
  }

  renderDealChecklistReview(){

    const imperatives = getSevenImperatives();
    const stages = getImperativesStages();

    return(
      <div className="verify-checklist">
        <h2>Verify Deal Progress</h2>
        <h3>Seven Imperative Progress</h3>
        <ul>
          {_.map(imperatives, this.renderImperative.bind(this))}
        </ul>
        <div className="objectives">
          <h3>Seller Objectives</h3>
          <ul>{_.map(stages.objectives, this.renderFunnelTask.bind(this))}</ul>
        </div>
        <div className="reciprocations">
          <h3>Buyer Reciprocations</h3>
          <ul>{_.map(stages.reciprocations, this.renderFunnelTask.bind(this))}</ul>
        </div>
      </div>
    )
  }

  renderDealForm(){

    const {
      _id,
      name,
      product,
      estimatedValue,
      estimatedCloseDate,
      status,
    } = this.state.deal;

    const estimatedCloseDateMoment = moment(estimatedCloseDate);

    const isNewDeal = _id ? false : true;

    const dealWon = status === 'won';

    return(
      <form className="velocity-form">
        <h2>{isNewDeal ? 'Add' : 'Update'} deal</h2>
        {this.renderFormMessage()}
        <div className="form-group">
          <div className="input-group two-thirds-width">
            <label htmlFor="deal-name">{dealWon ? 'Customer' : 'Prospect'}</label>
            <input
              ref={input => { this.dealNameInput = input; }}
              id="deal-name"
              autoComplete="off"
              type="text"
              value={name || ''}
              onChange={e => { this.updateDealProp('name', e.target.value); }}
              />
          </div>
          <div className="input-group third-width is-last-in-row">
            <label htmlFor="deal-name">Deal status</label>
            <Select
              classNamePrefix={'react-select'}
              className='react-select-container deal-status'
              value={this.getOptionForValue(STATUS_OPTIONS, status)}
              options={STATUS_OPTIONS}
              onChange={(option) => { this.updateDealProp('status', option.value); } }
              isSearchable={true}
            />
          </div>
        </div>
        <div className="form-group">
          <div className="input-group third-width">
            <label htmlFor="deal-product">Product or Service</label>
              <input
                id="deal-product"
                autoComplete="off"
                type="text"
                value={product || ''}
                onChange={e => { this.updateDealProp('product', e.target.value); }}
                />
          </div>
          <div className="input-group third-width">
            <label htmlFor="deal-close">{dealWon ? 'Closed on' : 'Estimated close date'}</label>
            <SingleDatePicker
              hideKeyboardShortcutsPanel={true}
              date={estimatedCloseDateMoment}
              onDateChange={date => { this.updateDealProp('estimatedCloseDate', date ? date.valueOf() : null); }}
              id="update-deal-estimated-close-date"
              focused={this.state.estimatedClosedDatePickerFocused}
              onFocusChange={({focused}) => { this.setState({ estimatedClosedDatePickerFocused: focused }); }}
              />
          </div>
          <div className="input-group third-width">
            <label htmlFor="deal-value">{dealWon ? 'Deal Value' : 'Estimated value'}</label>
            <NumericalInput
              id="deal-value"
              formatThousands={true}
              value={estimatedValue || ''}
              onUpdate={val => { this.updateDealProp('estimatedValue', val); }}
            />
          </div>
        </div>
      </form>
    )
  }

  render(){

    if(!this.props.visible){
      return null;
    }

    const { saving, verifyingChecklist } = this.state;

    return (
      <div className={`modal update-deal ${verifyingChecklist ? 'verifying-checklist' : ''}`}>
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.hide}>X</div>
          <div className="modal-content">
            {verifyingChecklist && this.renderDealChecklistReview()}
            {!verifyingChecklist && this.renderDealForm()}
          </div>
          <div className="modal-actions">
            {!this.formIsDirty() && !saving &&
              <button className="button primary" onClick={this.props.hide}>Done</button>
            }
            {(this.formIsDirty() || saving) &&
              <template>
                <button className="button primary" onClick={this.createOrUpdateDeal.bind(this)} disabled={saving}>{this.getSaveButtonText()}</button>
                <button className="button grey-button" onClick={this.props.hide}>{verifyingChecklist ? 'Make changes...' : 'Cancel'}</button>
              </template>
            }
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {

  }
}

export default connect(mapStateToProps, { createOrUpdateDeal })(UpdateDealModal);



// WEBPACK FOOTER //
// ./src/components/modals/updateDeal.js